import { RoutingAPI } from 'api'

// Rules
export const fetchRule = (ruleId) => {
  return RoutingAPI.get(`/rules/${ruleId}`).then((response) => response.data)
}

export const patchRule = (ruleId, updates, doBackfill = true) => {
  return RoutingAPI.patch(
    `/rules/${ruleId}?doBackfill=${doBackfill}`,
    updates
  ).then((response) => response.data)
}

export const updateOnCallUsers = (userIds) => {
  return RoutingAPI.patch('/rules/on_call', { userIds }).then(
    (response) => response.data
  )
}

export const postRule = (newRule, doBackfill = true) => {
  return RoutingAPI.post(`/rules?doBackfill=${doBackfill}`, newRule).then(
    (response) => response.data
  )
}

export const getAllRules = () => {
  return RoutingAPI.get('/rules/all')
    .then((response) => response.data)
    .then(({ rules, onCall }) => ({
      rules: rules,
      defaultRule: onCall,
    }))
}

export const runRoutingFallbacksBackfill = () => {
  return RoutingAPI.get('/rules/backfill/from_org_wait_properties')
}

// Rule groups
export const createRuleGroup = (treeId, group) => {
  return RoutingAPI.post('/rule-groups', {
    treeId,
    ...group,
  })
}

export const getRuleGroups = () => {
  return RoutingAPI.get('/rule-groups')
}

export const patchRuleGroup = (ruleGroup) => {
  ruleGroup.ruleIds = null
  return RoutingAPI.patch('/rule-groups', ruleGroup)
}

// Rule trees
export const getRuleTrees = () => {
  return RoutingAPI.get('/rule-trees')
}
